import {
    FETCH_AGENT_PROGRESSION_REQUEST,
    FETCH_AGENT_PROGRESSION_SUCCESS,
    FETCH_AGENT_PROGRESSION_FAILURE,

    FETCH_PROGRESSION_CONFIGURATIONS_REQUEST,
    FETCH_PROGRESSION_CONFIGURATIONS_SUCCESS,
    FETCH_PROGRESSION_CONFIGURATIONS_FAILURE,

    CREATE_PROGRESSION_CONFIGURATION_REQUEST,
    CREATE_PROGRESSION_CONFIGURATION_SUCCESS,
    CREATE_PROGRESSION_CONFIGURATION_FAILURE,

    UPDATE_PROGRESSION_CONFIGURATION_REQUEST,
    UPDATE_PROGRESSION_CONFIGURATION_SUCCESS,
    UPDATE_PROGRESSION_CONFIGURATION_FAILURE,

    DELETE_PROGRESSION_CONFIGURATION_REQUEST,
    DELETE_PROGRESSION_CONFIGURATION_SUCCESS,
    DELETE_PROGRESSION_CONFIGURATION_FAILURE,
} from "./types";


import {
    getAgentProgression,
    fetchProgressionConfigurations,
    createProgressionConfiguration,
    updateProgressionConfiguration,
    deleteProgressionConfiguration,
} from "../../services/agentProgressionService";


export const fetchAgentProgressionRequest = () => ({
    type: FETCH_AGENT_PROGRESSION_REQUEST,
});

export const fetchAgentProgressionSuccess = (data) => ({
    type: FETCH_AGENT_PROGRESSION_SUCCESS,
    payload: data,
});

export const fetchAgentProgressionFailure = (error) => ({
    type: FETCH_AGENT_PROGRESSION_FAILURE,
    payload: error,
});

export const fetchProgressionConfigurationsRequest =
    () => ({

        type:
            FETCH_PROGRESSION_CONFIGURATIONS_REQUEST,

    });



export const fetchProgressionConfigurationsSuccess =
    (configurations) => ({

        type:
            FETCH_PROGRESSION_CONFIGURATIONS_SUCCESS,

        payload:
            configurations,

    });



export const fetchProgressionConfigurationsFailure =
    (error) => ({

        type:
            FETCH_PROGRESSION_CONFIGURATIONS_FAILURE,

        payload:
            error,

    });



export const createProgressionConfigurationRequest =
    () => ({

        type:
            CREATE_PROGRESSION_CONFIGURATION_REQUEST,

    });



export const createProgressionConfigurationSuccess =
    (configuration) => ({

        type:
            CREATE_PROGRESSION_CONFIGURATION_SUCCESS,

        payload:
            configuration,

    });



export const createProgressionConfigurationFailure =
    (error) => ({

        type:
            CREATE_PROGRESSION_CONFIGURATION_FAILURE,

        payload:
            error,

    });



export const updateProgressionConfigurationRequest =
    () => ({

        type:
            UPDATE_PROGRESSION_CONFIGURATION_REQUEST,

    });



export const updateProgressionConfigurationSuccess =
    (configuration) => ({

        type:
            UPDATE_PROGRESSION_CONFIGURATION_SUCCESS,

        payload:
            configuration,

    });



export const updateProgressionConfigurationFailure =
    (error) => ({

        type:
            UPDATE_PROGRESSION_CONFIGURATION_FAILURE,

        payload:
            error,

    });



export const deleteProgressionConfigurationRequest =
    () => ({

        type:
            DELETE_PROGRESSION_CONFIGURATION_REQUEST,

    });



export const deleteProgressionConfigurationSuccess =
    (configurationId) => ({

        type:
            DELETE_PROGRESSION_CONFIGURATION_SUCCESS,

        payload:
            configurationId,

    });



export const deleteProgressionConfigurationFailure =
    (error) => ({

        type:
            DELETE_PROGRESSION_CONFIGURATION_FAILURE,

        payload:
            error,

    });


export const fetchAgentProgression = (agentId) => async (dispatch) => {
    dispatch(fetchAgentProgressionRequest());

    try {
        const response = await getAgentProgression(agentId);

        if (response.success) {
            dispatch(fetchAgentProgressionSuccess(response.data));

            return {
                success: true,
                data: response.data,
            };
        }

        dispatch(fetchAgentProgressionFailure(response.error));

        return {
            success: false,
            error: response.error,
        };
    } catch (error) {
        const message =
            error.response?.data?.detail ||
            error.response?.data?.message ||
            error.message ||
            "Failed to retrieve agent progression.";

        dispatch(fetchAgentProgressionFailure(message));

        return {
            success: false,
            error: message,
        };
    }
};


export const fetchProgressionConfigurationsAction =
    () => async (dispatch) => {

        dispatch(
            fetchProgressionConfigurationsRequest()
        );


        try {

            const response =
                await fetchProgressionConfigurations();


            if (
                response.success
            ) {

                dispatch(
                    fetchProgressionConfigurationsSuccess(
                        response.data
                    )
                );


                return {
                    success: true,
                    data:
                        response.data,
                };

            }


            dispatch(
                fetchProgressionConfigurationsFailure(
                    response.error
                )
            );


            return {
                success: false,
                error:
                    response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to fetch progression configurations";


            dispatch(
                fetchProgressionConfigurationsFailure(
                    message
                )
            );


            return {
                success: false,
                error:
                    message,
            };

        }
    };




export const createProgressionConfigurationAction =
    (payload) => async (dispatch) => {

        dispatch(
            createProgressionConfigurationRequest()
        );


        try {

            const response =
                await createProgressionConfiguration(
                    payload
                );


            if (
                response.success
            ) {

                dispatch(
                    createProgressionConfigurationSuccess(
                        response.data
                    )
                );


                return {
                    success: true,
                    data:
                        response.data,
                };

            }


            dispatch(
                createProgressionConfigurationFailure(
                    response.error
                )
            );


            return {
                success: false,
                error:
                    response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to create progression configuration";


            dispatch(
                createProgressionConfigurationFailure(
                    message
                )
            );


            return {
                success: false,
                error:
                    message,
            };

        }
    };



export const updateProgressionConfigurationAction =
    (
        configurationId,
        payload
    ) => async (dispatch) => {

        dispatch(
            updateProgressionConfigurationRequest()
        );


        try {

            const response =
                await updateProgressionConfiguration(
                    configurationId,
                    payload
                );


            if (
                response.success
            ) {

                dispatch(
                    updateProgressionConfigurationSuccess(
                        response.data
                    )
                );


                return {
                    success: true,
                    data:
                        response.data,
                };

            }


            dispatch(
                updateProgressionConfigurationFailure(
                    response.error
                )
            );


            return {
                success: false,
                error:
                    response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to update progression configuration";


            dispatch(
                updateProgressionConfigurationFailure(
                    message
                )
            );


            return {
                success: false,
                error:
                    message,
            };

        }
    };



export const deleteProgressionConfigurationAction =
    (configurationId) => async (dispatch) => {

        dispatch(
            deleteProgressionConfigurationRequest()
        );


        try {

            const response =
                await deleteProgressionConfiguration(
                    configurationId
                );


            if (
                response.success
            ) {

                dispatch(
                    deleteProgressionConfigurationSuccess(
                        configurationId
                    )
                );


                return {
                    success: true,
                    data:
                        response.data,

                    message:
                        response.message,
                };

            }


            dispatch(
                deleteProgressionConfigurationFailure(
                    response.error
                )
            );


            return {
                success: false,
                error:
                    response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to delete progression configuration";


            dispatch(
                deleteProgressionConfigurationFailure(
                    message
                )
            );


            return {
                success: false,
                error:
                    message,
            };

        }
    };